import $ from 'jquery'
import 'jquery-modal'
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'

export default class BrVideoPlayer extends HTMLElement {
    static MAX_VIDEO_WIDTH = 1024
    videoContainer: HTMLDivElement | null = null
    videoPlyrInst: Plyr | null = null

    buildVideo() {
        const containerEl = document.createElement('div')
        const plyrVideo = document.createElement('video')
        const plyrSource = document.createElement('source')
        const widthWidth = parseInt(`${this.dataset.videoWidth}`, 10)

        containerEl.className = 'modal modal-video'
        containerEl.style.setProperty(
            '--modal-max-width',
            `${widthWidth > BrVideoPlayer.MAX_VIDEO_WIDTH ? BrVideoPlayer.MAX_VIDEO_WIDTH : widthWidth}px`
        )
        plyrVideo.setAttribute('controls', 'true')
        plyrVideo.setAttribute('autoplay', this.dataset.autoplay === '1' ? 'true' : 'false')
        plyrSource.setAttribute('src', `${this.dataset.videoUrl}`)
        plyrSource.setAttribute('type', `${this.dataset.videoType}`)
        plyrSource.setAttribute('size', `${this.dataset.videoWidth}`)

        $(plyrSource).appendTo(plyrVideo)
        $(plyrVideo).appendTo(containerEl)
        $(containerEl).appendTo('body')

        // Init Plyr video
        this.videoPlyrInst = new Plyr(plyrVideo, {
            loadSprite: this.dataset.iconUrl === undefined,
            iconUrl: this.dataset.iconUrl,
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
        })
        this.videoContainer = containerEl
    }

    onKillModal() {
        this.videoPlyrInst?.stop()
        this.videoPlyrInst?.destroy()
        $(this.videoContainer as HTMLDivElement).remove()
        this.videoContainer = null
    }

    playVideo() {
        if (!this.videoContainer) this.buildVideo()
        $(this.videoContainer as HTMLDivElement).modal()
        $(this.videoContainer as HTMLDivElement).on($.modal.AFTER_CLOSE, this.onKillModal.bind(this))
    }

    init() {
        // Set style display
        this.style.display = this.dataset.display ?? 'inline-block'
        // Get trigger element
        const triggerEl: HTMLButtonElement | HTMLAnchorElement | null = this.querySelector('.video-trigger')

        // Open video modal
        if (triggerEl && this.dataset.videoUrl) {
            triggerEl.addEventListener('click', event => {
                if (triggerEl instanceof HTMLAnchorElement) event.preventDefault()
                this.playVideo()
            })
        }
    }

    connectedCallback() {
        setTimeout(() => {
            this.init()
        })
    }
}
